var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-circles"},_vm._l((Math.round(Math.random()*5+5)),function(i){return _c('div',{key:i,staticClass:"c",style:({
	  background: _vm.colorDark, 
	  top: _vm.hi==_vm.active_hover?((Math.random()*70+10) + "%"):((Math.random()*70+10) + "%"),
	  visibility: _vm.hi==_vm.active_hover?'visible':'hidden', 
	  left: _vm.hi==_vm.active_hover?((Math.random()*70+10) + "%"):((Math.random()<0.5?100:0) + "%")})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }